import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Careers = () => {
  return (
    <div data-testid="careers-page">
      {/* Hero Section */}
      <section className="py-20 bg-[#14366C]" data-testid="careers-hero">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-oswald uppercase text-4xl md:text-5xl font-bold text-white mb-4">
              Careers at BNPH
            </h1>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto">
              Join our team of dedicated plumbing and heating professionals serving the Twin Cities since 1976.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Coming Soon Content */}
      <section className="py-20 bg-white" data-testid="careers-content">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-oswald uppercase text-3xl font-bold text-[#14366C] mb-6">
              We're Always Looking for Talented People
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed">
              Bruce Nelson Plumbing & Heating Services is a growing company with opportunities for skilled tradespeople. We offer competitive wages, benefits, and a supportive work environment.
            </p>
            
            <div className="bg-[#F8F8F8] p-8 rounded-lg mb-8">
              <h3 className="font-oswald uppercase text-xl font-bold text-[#14366C] mb-4">
                Current Openings
              </h3>
              <p className="text-gray-600">
                Please check back soon or contact us directly for current employment opportunities.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="font-oswald uppercase text-xl font-bold text-[#14366C]">
                Contact Us About Employment
              </h3>
              <div className="flex flex-col md:flex-row justify-center gap-6 text-gray-600">
                <a href="tel:651-738-9354" className="flex items-center gap-2 hover:text-[#F58220] transition-colors justify-center">
                  <Phone className="w-5 h-5" />
                  (651) 738-9354
                </a>
                <a href="mailto:info@brucenelsonph.com" className="flex items-center gap-2 hover:text-[#F58220] transition-colors justify-center">
                  <Mail className="w-5 h-5" />
                  info@brucenelsonph.com
                </a>
              </div>
              <div className="flex items-center gap-2 text-gray-600 justify-center">
                <MapPin className="w-5 h-5" />
                7012 6th St. N., Oakdale, MN 55128
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-[#14366C]">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="font-oswald uppercase text-2xl font-bold text-white mb-4">
            Not Looking for a Job?
          </h2>
          <p className="text-gray-300 mb-6">
            If you need plumbing or heating services, we're here to help!
          </p>
          <Link 
            to="/contact"
            className="inline-block bg-[#F58220] hover:bg-[#e07010] text-white font-oswald font-bold uppercase tracking-wider px-8 py-3 transition-colors"
          >
            Request Service
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Careers;
